import { styled } from "@mui/material/styles";
import UserIconSvg from "assets/images/icons/user-badge.svg";

export const Container = styled("div", { label: "trip-details" })`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.palette.color.secondary[100]};
  border-radius: ${({ theme }) => theme.spacing(4)};
`;

export const UserIcon = styled(UserIconSvg, {
  label: "user-icon",
})`
  width: ${({ theme }) => theme.spacing(3)};
  fill: ${({ theme }) => theme.palette.color.primary.main};
  vertical-align: bottom;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;
